import React, { useEffect, createElement } from 'react';
export function MetaPixel() {
  useEffect(() => {
    // Initialize fbq function
    // @ts-ignore
    if (window.fbq) return;
    // @ts-ignore
    const n: any = window.fbq = function () {
      n.callMethod ? n.callMethod.apply(n, arguments) : n.queue.push(arguments);
    };
    // @ts-ignore
    window._fbq = n;
    n.push = n;
    n.loaded = true;
    n.version = '2.0';
    n.queue = [];
    // Load the FB pixel script safely by appending to head
    const script = document.createElement('script');
    script.async = true;
    script.src = 'https://connect.facebook.net/en_US/fbevents.js';
    document.head.appendChild(script);
    // @ts-ignore
    window.fbq('init', '832917643091578');
    // @ts-ignore
    window.fbq('track', 'PageView');
  }, []);
  return <noscript data-id="element-152">
      <img height="1" width="1" style={{
      display: 'none'
    }} src="https://www.facebook.com/tr?id=832917643091578&ev=PageView&noscript=1" alt="" data-id="element-153" />
    </noscript>;
}